module.exports = __webpack_public_path__ + "img/18-villas.65407ab6.jpg";